import type { Feature } from 'geojson'
import type mapboxgl from 'mapbox-gl'
import * as turf from '@turf/turf'

const DEGENERATE_BBOX_THRESHOLD = 1e-8

/**
 * Fit bounds or fly to center for point-like geometries.
 */
export function flyMapToLngLat(
  map: mapboxgl.Map,
  lng: number,
  lat: number,
): void {
  map.flyTo({ center: [lng, lat], zoom: 16, duration: 1200 })
}

export function flyMapToFeature(map: mapboxgl.Map, feature: Feature): void {
  if (!feature.geometry) return

  try {
    const [west, south, east, north] = turf.bbox(feature as turf.Feature)
    const lonSpan = east - west
    const latSpan = north - south

    if (lonSpan < DEGENERATE_BBOX_THRESHOLD && latSpan < DEGENERATE_BBOX_THRESHOLD) {
      const c = turf.centroid(feature as turf.Feature)
      const [lng, lat] = c.geometry.coordinates
      flyMapToLngLat(map, lng, lat)
      return
    }

    map.fitBounds(
      [
        [west, south],
        [east, north],
      ],
      { padding: 72, maxZoom: 17, duration: 1200 },
    )
  } catch (err) {
    console.warn('[smart-search] flyMapToFeature failed', err)
  }
}
